import { forgotPasswordInputSchema } from '@dovefiniscono/shared';
import { Link, Navigate } from '@tanstack/react-router';
import { type FormEvent, useState } from 'react';
import { api, errorMessage } from '../../lib/api';
import { cx } from '../../lib/cx';
import { type FieldErrors, validate } from '../../lib/form';
import { useSession } from '../../lib/session';
import { Button } from '../../ui/Button';
import { TextField } from '../../ui/Field';
import styles from './Auth.module.css';
import { AuthLayout } from './AuthLayout';

export function ForgotPasswordPage() {
  const { passwordSignIn } = useSession();
  const [errors, setErrors] = useState<FieldErrors>({});
  const [formError, setFormError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const result = validate(forgotPasswordInputSchema, {
      email: new FormData(event.currentTarget).get('email'),
    });
    setErrors(result.errors ?? {});
    setFormError(null);
    if (!result.data) return;
    setLoading(true);
    try {
      await api.auth.forgotPassword(result.data);
      setSent(true);
    } catch (error) {
      setFormError(errorMessage(error));
    } finally {
      setLoading(false);
    }
  }

  if (passwordSignIn === false) return <Navigate to="/login" />;

  return (
    <AuthLayout
      title="Password dimenticata"
      subtitle="Ti mandiamo un link per sceglierne una nuova."
    >
      {sent ? (
        <p className={cx(styles.notice, styles.success)} role="status">
          Se l'indirizzo è registrato, il link è in arrivo. Controlla anche lo spam.
        </p>
      ) : (
        <form className={styles.fields} onSubmit={submit} noValidate>
          <TextField
            label="Email"
            name="email"
            type="email"
            autoComplete="email"
            autoFocus
            error={errors.email}
          />
          {formError ? (
            <p className={styles.notice} role="alert">
              {formError}
            </p>
          ) : null}
          <Button type="submit" variant="primary" className={styles.submit} loading={loading}>
            Invia il link
          </Button>
        </form>
      )}
      <div className={styles.links}>
        <Link to="/login">Torna all'accesso</Link>
      </div>
    </AuthLayout>
  );
}
